import {Component, Input} from '@angular/core';
import {Signaalkaart} from '../signaalkaart';
import {Client} from '../../client/client';

@Component({
    selector: 'zah-signaalkaart-header',
    templateUrl: './signaalkaart-header.component.html',
    styleUrls: ['./signaalkaart-header.component.scss'],
    standalone: false
})
export class SignaalkaartHeaderComponent {

  @Input()
  signaalkaart: Signaalkaart;
  @Input()
  client: Client;
}
